module.exports = __webpack_public_path__ + "static/media/remove.0722aa41.svg";